import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { UnitOfMeasureTypes } from '../../enumerations/unit-of-measure-type';
import { IKeypadState } from '../../interfaces/states/IKeypadState';

const initialState: IKeypadState = {
  visible: true,
  itemCode: '',
  metricValue: 1,
  type: UnitOfMeasureTypes.Quantity,
  quantityEntered: false,
};

class SalesKeypadReducer extends ImmerReducer<IKeypadState> {
  public resetSalesKeypad(): void {
    this.draftState = initialState;
  }

  public setSalesKeypadState(state: Partial<IKeypadState>): void {
    this.draftState = { ...this.draftState, ...state };
  }
}

export const SalesKeypadActions = createActionCreators(SalesKeypadReducer);
export const SalesKeypadReducerFunction = createReducerFunction(SalesKeypadReducer, initialState);
